import dayjs from "dayjs";
import { VISUAL_DATE_FORMAT } from "app/pages/app-intelligence/constants";
import DurationService from "app/services/DurationService";
import { DeviceService } from "app/pages/app-intelligence/common-components/device-picker/DeviceService";
import type { EDevice, IDeviceFilterItem } from "app/pages/app-intelligence/common-components/device-picker/types";
import { fullMonthAndYear, shortMonthAndYear } from "@similarweb/pro-logic-components";

const singleDayDuration = "1d";

export interface IWidgetSelectionsSubtitles {
    device?: string | EDevice;
    duration: string;
    country?: {
        id: string;
        text: string;
    };
    webSource?: string;
}

const getWidgetSubtitles = (
    selections?: IWidgetSelectionsSubtitles,
    useSingleDayFormat = false,
    date = null,
    showDevice = true,
    showCountry = true,
    dateText = null,
    showWebSource = false,
): any[] => {
    let selectedDevice: IDeviceFilterItem | undefined;
    if (showDevice) {
        // @ts-ignore FIXME: strict migration - Argument of type 'string | undefined' is not assignable to parameter of type 'string' — DeviceService handles undefined device type
        selectedDevice = DeviceService.getDeviceTranslatedByType(selections?.device);
    }
    const durationSubtitle = getDateSubtitle(selections?.duration, useSingleDayFormat, date, dateText);
    return [
        durationSubtitle,
        showCountry && {
            filter: "country",
            countryCode: selections?.country?.id,
            value: selections?.country?.text,
        },
        showDevice && {
            filter: "icon",
            iconName: selectedDevice?.icon,
            value: selectedDevice?.text,
        },
        showWebSource && {
            filter: "webSource",
            value: selections?.webSource,
        },
    ];
};

const shouldPresentSingleDay = (durationId: FixmeType, date: FixmeType, dateText: FixmeType, useSingleDayFormat: FixmeType) => {
    const isValidDateAsSingleDate =
        dayjs(date).isValid() ||
        dayjs(dateText).isValid() ||
        (dayjs(dateText?.split("-")?.[0]).isValid() &&
            dayjs(dateText?.split("-")?.[1]).isValid() &&
            dayjs(dateText?.split("-")?.[0]) === dayjs(dateText?.split("-")?.[1]));
    const isSingleDayDuration = durationId === singleDayDuration && isValidDateAsSingleDate;
    return useSingleDayFormat || isSingleDayDuration;
};
const getDateSubtitle = (durationId: FixmeType, useSingleDayFormat: FixmeType, date: FixmeType, dateText?: FixmeType) => {
    const useSingleDAy = shouldPresentSingleDay(durationId, date, dateText, useSingleDayFormat);
    if (useSingleDAy) {
        const dateToValidate = date ? date : dateText.includes("-") ? dateText.split("-")[0] : dateText;
        return {
            filter: "icon",
            iconName: "daily-ranking",
            value: dayjs(dateToValidate).format(VISUAL_DATE_FORMAT),
        };
    } else if (dateText) {
        return {
            filter: "icon",
            iconName: "daily-ranking",
            value: dateText,
        };
    } else {
        const isOneMonthSelected = DurationService.isLessThanOrEqualToOneMonths(durationId);
        const { from, to } = DurationService.getDurationData(durationId).forAPI;
        return {
            filter: "date",
            value: {
                from: from.valueOf(),
                to: to.valueOf(),
                useRangeDisplay: !isOneMonthSelected,
            },
            format: isOneMonthSelected ? fullMonthAndYear : shortMonthAndYear,
        };
    }
};

export const WidgetService = {
    getWidgetSubtitles,
};
